import { useState, useEffect } from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, Text } from '@pancakeswap/uikit'
import { ethers } from 'ethers'
import abi from '../../../abi/lottery.abi.json'

const StyledCard = styled(Flex)`
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-shadow: ${({ theme }) => (theme.isDark ? '' : '8px 12px 12px rgba(15, 20, 30, 0.12)')};
`

const StyledLotteryDigit = styled(Text)`
  font-size: 16px;
  font-weight: 700;
  color: white;
  background: url('/lotterydigitbg.png') no-repeat center center / cover;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 120px;
`

const LastWinningNumbers = ({ genericprovider }) => {
  const theme = useTheme()
  const contractAddress = '0x043C2e5100A7157c36D677af0BbD62F76bB7E7D7'

  const [selectedCycle, setSelectedCycle] = useState(0)
  const [winningNumbers, setWinningNumbers] = useState([])

  useEffect(() => {
    const contract = new ethers.Contract(contractAddress, abi, genericprovider)
    contract.functions.currentCycle().then((currentCycleResp) => {
      const currentCycle = currentCycleResp[0].toNumber()
      contract.functions.viewCycleWinnerNumbers(currentCycle).then((viewCycleWinnerNumbersResp) => {
        const currentCycleNumbers = viewCycleWinnerNumbersResp[0].map((num) => num.toNumber())
        const sum = currentCycleNumbers.reduce((a, b) => a + b, 0)
        if (sum > 0) {
          setSelectedCycle(currentCycle)
          setWinningNumbers(currentCycleNumbers)
        }
        if (currentCycle > 1) {
          contract.functions.viewCycleWinnerNumbers(currentCycle - 1).then((viewPastCycleWinnerNumbersResp) => {
            setSelectedCycle(currentCycle - 1)
            setWinningNumbers(viewPastCycleWinnerNumbersResp[0].map((num) => num.toNumber()))
          })
        } else {
          setWinningNumbers([0, 0, 0, 0, 0, 0])
        }
      })
    })
  }, [])

  return (
    <StyledCard style={{ flexDirection: 'column', marginTop: 40 }}>
      <Text style={{ marginTop: 20 }}>
        Last Winning Numbers
        {selectedCycle === 0 || winningNumbers.length === 0 ? <></> : <span> - Draw #{selectedCycle}</span>}
      </Text>
      <Flex style={{ marginTop: 28, gap: 8, marginBottom: 40 }}>
        {winningNumbers.length === 0 ? (
          <div>Loading...</div>
        ) : (
          <>
            <StyledLotteryDigit>{winningNumbers[0]}</StyledLotteryDigit>
            <StyledLotteryDigit>{winningNumbers[1]}</StyledLotteryDigit>
            <StyledLotteryDigit>{winningNumbers[2]}</StyledLotteryDigit>
            <StyledLotteryDigit>{winningNumbers[3]}</StyledLotteryDigit>
            <StyledLotteryDigit>{winningNumbers[4]}</StyledLotteryDigit>
            <StyledLotteryDigit>{winningNumbers[5]}</StyledLotteryDigit>
          </>
        )}
      </Flex>
    </StyledCard>
  )
}

export default LastWinningNumbers
